import Attachments from './Attachment.jsx';

export default Attachments;
